import { render, staticRenderFns } from "./WorkflowEditStatusCategory.vue?vue&type=template&id=257cd221"
import script from "./WorkflowEditStatusCategory.vue?vue&type=script&lang=js"
export * from "./WorkflowEditStatusCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports